import { render, staticRenderFns } from "./demographics.vue?vue&type=template&id=5c1a6ace&scoped=true"
import script from "./demographics.vue?vue&type=script&lang=js"
export * from "./demographics.vue?vue&type=script&lang=js"
import style0 from "./demographics.vue?vue&type=style&index=0&id=5c1a6ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1a6ace",
  null
  
)

export default component.exports